import { Tilt as Hamburger } from './Tilt';
import { Fade } from './Fade';
import { Sling } from './Sling';
import { Spin } from './Spin';
import { Squash } from './Squash';
import { Turn } from './Turn';
import { Twirl } from './Twirl';
export default Hamburger;
export { Fade, Sling, Spin, Squash, Turn, Twirl };